/**
 * An implementation of generateSearchUrl to be shared by all
 * iHotelier/Travelclick family engines. It performs mangling
 * and formatting of the query string parameters and data.
 * The validation of the URL is expected to be done on each specific
 * engine before calling this base function.
 */
const generateSearchUrlBase = (ctx) => {
    const url = new URL(ctx.baseUrl);
    if (!url) {
        return { newUrl: '', newData: {} };
    }
    // remove params if they exist
    url.searchParams.delete('datein');
    url.searchParams.delete('DateIn');
    url.searchParams.delete('dateIn');
    url.searchParams.delete('dateout');
    url.searchParams.delete('dateOut');
    url.searchParams.delete('DateOut');
    url.searchParams.delete('adults');
    url.searchParams.delete('Adults');
    url.searchParams.delete('children');
    url.searchParams.delete('Children');
    url.searchParams.delete('languageid');
    url.searchParams.delete('languageID');
    url.searchParams.delete('nights');
    url.searchParams.delete('rooms');
    url.searchParams.delete('currency');
    url.searchParams.delete('groupID');
    url.searchParams.delete('identifier');
    // multi room case
    const roomsDispo = ctx.data?.roomsDispo;
    if (roomsDispo && roomsDispo.length > 1) {
        roomsDispo.forEach((room, index, list) => {
            if (index === 0) {
                // set new params for first room
                url.searchParams.set('adults', '[adults]');
                url.searchParams.set('children', '[children]');
            }
            // remove params if they exist
            url.searchParams.delete(`adults${index + 1}`);
            url.searchParams.delete(`children${index + 1}`);
            url.searchParams.delete(`Adults${index + 1}`);
            url.searchParams.delete(`Children${index + 1}`);
            // set new params
            url.searchParams.set(`adults${index + 1}`, String(room.adults));
            url.searchParams.set(`children${index + 1}`, String(room.children));
            url.searchParams.set('rooms', String(list.length));
        });
    }
    else {
        // set new params
        url.searchParams.set('adults', '[adults]');
        if (ctx.data?.roomsDispo?.[0]?.children && ctx.data?.roomsDispo?.[0]?.children > 0) {
            url.searchParams.set('children', '[children]');
            if (url.pathname.match(/SUHA-creek-hotel-apartments/)) {
                url.searchParams.set('childAge', ctx.data?.roomsDispo?.[0]?.childrenAges?.fill(0)?.join(',') ?? '0');
            }
            else {
                url.searchParams.set('childAge', ctx.data?.roomsDispo?.[0]?.childrenAges?.join(',') ?? '0');
            }
        }
        url.searchParams.set('rooms', '[rooms]');
    }
    // set new params
    url.searchParams.set('DateIn', '[date_begin]');
    url.searchParams.set('DateOut', '[date_end]');
    url.searchParams.set('languageid', '[language]');
    if (url.hostname.match(/hotelsunsetplaza/)) {
        url.searchParams.set('currency', 'USD');
    }
    else {
        url.searchParams.set('currency', '[currency]');
    }
    if (ctx.data?.language === 'sv') { // all the swedish users has to redirect to SEK currency
        url.searchParams.set('currency', 'SEK');
    }
    const newUrl = url.toString();
    const newData = {
        ...ctx.data,
        // Format some params to match the URL structure
        language: ctx.data?.language === 'sv' ? 'se' : ctx.data?.language,
        dateBegin: ctx.data?.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$2/$3/$1'),
        dateEnd: ctx.data?.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$2/$3/$1'),
    };
    return { newUrl, newData };
};

export { generateSearchUrlBase as g };
